import { useLayoutEffect, useState } from 'react';

import useResizeObserver from '@react-hook/resize-observer';

export default function useSize(target) {
  const targetEl = target?.current || target;

  const [size, setSize] = useState(() =>
    targetEl ?
      { width: targetEl.offsetWidth, height: targetEl.offsetHeight }
    : { width: 0, height: 0 },
  );

  useLayoutEffect(() => {
    if (targetEl) {
      setSize({ width: targetEl.offsetWidth, height: targetEl.offsetHeight });
    }
  }, [targetEl]);

  useResizeObserver(target, (entry) => {
    const entryTargetEl = entry.target;

    setSize({
      width: entryTargetEl.offsetWidth,
      height: entryTargetEl.offsetHeight,
    });
  });

  return size;
}
